var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVerticalLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M20,38h0a4,4,0,0,1,4-4h0a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4h0A4,4,0,0,1,20,38Zm4-10h0a4,4,0,0,0,4-4h0a4,4,0,0,0-4-4h0a4,4,0,0,0-4,4h0A4,4,0,0,0,24,28Zm0-14h0a4,4,0,0,0,4-4h0a4,4,0,0,0-4-4h0a4,4,0,0,0-4,4h0A4,4,0,0,0,24,14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVerticalLight);
export default __webpack_public_path__ + "static/media/moreVerticalLight.a93e3da94b81d4075786c6909298723a.svg";
export { ForwardRef as ReactComponent };